/**
 * Full-page navigation (not an in-app RSC transition).
 *
 * Use when the client must fully re-initialize against a new auth state — after
 * login, or when the session expires — because an RSC transition keeps the stale
 * client SessionProvider (see LoginForm's post-login redirect for the same reason).
 */
export function hardNavigate(url: string): void {
  window.location.assign(url)
}
